import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import previous from "../assets/images/previous.svg";
import question from "../assets/images/question.svg";
import { useTranslation } from "react-i18next";
//heroicons içerisinden chevronleft'i import et
import {
  ChevronLeftIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/20/solid";

function Header() {
  const [backSpace, setBackSpace] = useState();
  const [showQuestionMark, setShowQuestionMark] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateControl = () => {
    // if (location.pathname === "/confirm-attribute") {
    //   navigate("/confirm-attribute");
    // } else {
    navigate("/");
    // }
  };

  useEffect(() => {
    location.pathname === "/support"
      ? setShowQuestionMark(false)
      : setShowQuestionMark(true);
    if (
      location.pathname === "/" ||
      location.pathname === "/confirm-attribute"
    ) {
      return setBackSpace(false);
    } else {
      return setBackSpace(true);
    }
  }, [location.pathname]);

  return (
    <div className="header">
      <div className="mobil-header-icon go-back">
        {backSpace && (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1) || navigate("/")}
          >
            <ChevronLeftIcon
              className=""
              style={{ width: 32 + "px", height: 32 + "px" }}
            />
          </div>
        )}
      </div>
      <div onClick={() => navigateControl()}>
        <h1 className="title">CYLINDA {t("header.title")}</h1>
        {/* <p className="title-desc">{t("header.description")}</p> */}
        <br></br>
      </div>
      <div className="mobil-header-icon">
        {showQuestionMark ? (
          <div className="mobil-header-question-icon">
            <QuestionMarkCircleIcon
              className=""
              style={{ width: 38 + "px", height: 38 + "px", color: "#f3a18c" }}
              onClick={() => navigate("/support")}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default Header;
